import { http } from '../utils/axios';
import { ILanguagesResponse } from '../interfaces/language.interface';

class LanguageService {
  private static instance: LanguageService;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  static getInstance(): LanguageService {
    if (!LanguageService.instance) {
      LanguageService.instance = new LanguageService();
    }

    return LanguageService.instance;
  }

  getLanguages = async () => {
    const { data } = await http<ILanguagesResponse>({
      url: '/i18n/languages',
      method: 'GET'
    });
    return data.languages;
  };
}

const instance = LanguageService.getInstance();

export default instance;
